import { useState, useEffect, useRef, useCallback } from 'react';
import mqtt from 'mqtt';
import dialerService from '../services/dialerService';

export const useMqttDialer = (uniqueIdentity) => {
  const [callStatus, setCallStatus] = useState('Requesting');
  const [isCallConnected, setIsCallConnected] = useState(false);
  const [callDuration, setCallDuration] = useState(0);
  const [customerDuration, setCustomerDuration] = useState(0);
  const [agentDuration, setAgentDuration] = useState(0);
  
  const clientRef = useRef(null);
  const timerRef = useRef(null);
  const agentTimerRef = useRef(null);
  const customerTimerRef = useRef(null);

  const startTimers = useCallback(() => {
    if (!timerRef.current) {
      timerRef.current = setInterval(() => {
        setCallDuration(prev => prev + 1);
      }, 1000);
    }
  }, []);

  const stopAllTimers = useCallback(() => {
    clearInterval(timerRef.current);
    clearInterval(agentTimerRef.current);
    clearInterval(customerTimerRef.current);
    timerRef.current = null;
    agentTimerRef.current = null;
    customerTimerRef.current = null;
  }, []);

  const handleStatusChange = useCallback((mqttStatus) => {
    const { EndpointMode, CustomerStatus } = mqttStatus;

    switch (EndpointMode) {
      case 'AgentAnswer':
        setCallStatus('Agent Answer');
        if (!agentTimerRef.current) {
          agentTimerRef.current = setInterval(() => setAgentDuration(prev => prev + 1), 1000);
        }
        break;
      case 'CustomerDailing':
        setCallStatus('Dialing to Customer');
        break;
      case 'CustomerAnswer':
        setCallStatus('Customer Answer');
        setIsCallConnected(true);
        if (!customerTimerRef.current) {
          customerTimerRef.current = setInterval(() => setCustomerDuration(prev => prev + 1), 1000);
        }
        break;
      case 'CallDisconnected':
        setCallStatus(`Disconnected: ${CustomerStatus || ''}`);
        stopAllTimers();
        if (uniqueIdentity) {
          dialerService.updateFailedCallStatus(uniqueIdentity, 'Failed');
        }
        break;
      default:
        setCallStatus('Disconnected');
        stopAllTimers();
        break;
    }
  }, [uniqueIdentity, stopAllTimers]);

  useEffect(() => {
    if (!uniqueIdentity) return;

    const client = mqtt.connect("wss://mqtt.kit19.com:8084/mqtt", {
      username: "netadmin",
      password: "admin",
    });

    clientRef.current = client;

    client.on("connect", () => {
      console.log("Connected to MQTT broker");
      client.subscribe("VoipClickToCall");
      setCallStatus('Submitted');
      startTimers();
    });

    client.on("message", (topic, message) => {
      try {
        const payload = JSON.parse(message.toString());
        if (payload.UniqueIdentity === uniqueIdentity && payload.ProviderName === "Kit19 80") {
          const statusDetails = JSON.parse(payload.Status);
          handleStatusChange(statusDetails);
        }
      } catch (error) {
        console.error("MQTT Message parsing error:", error);
      }
    });

    return () => {
      if (clientRef.current) {
        clientRef.current.end();
      }
      stopAllTimers();
    };
  }, [uniqueIdentity, handleStatusChange, startTimers, stopAllTimers]);

  return {
    callStatus,
    isCallConnected,
    callDuration,
    customerDuration,
    agentDuration,
    setCallStatus
  };
};
